/***********************************************
 * useWaveform
 *
 * Implement the wavesurfer library
 * https://wavesurfer-js.org/docs/
 *
 * Supports waveform with player or media stream
 *
 * onWaveformFinish can be assigned a callback for playback end.
 ***********************************************/
import { ref, watch } from "vue";
import WaveSurfer from "wavesurfer.js";
export const useWaveform = (initialConfig, currentTime) => {
    const config = initialConfig || ref({});
    const segments = ref([]);
    watch(currentTime, () => {
        segments.value.forEach((s) => s.wavesurfer.setCurrentTime(Math.max(0, currentTime.value - s.offset)));
    });
    const waveformPlayerPlay = (el, offset, duration, url) => {
        const conf = JSON.parse(JSON.stringify(config.value));
        conf.container = el;
        const wavesurfer = WaveSurfer.create(conf);
        const segment = { wavesurfer, offset, duration };
        segments.value.push(segment);
        wavesurfer.load(url);
    };
    return {
        waveformPlayerPlay
    };
};
